<template>
  <div class="fixed bottom-6 right-6 z-50">
    <transition name="fab-menu">
      <div v-if="expanded" class="absolute bottom-16 right-0 flex flex-col gap-2">
        <button
          v-for="action in actions"
          :key="action.id"
          @click="action.handler"
          class="glass-card p-3 rounded-full hover-lift group"
          :title="action.label"
        >
          <component :is="action.icon" class="w-5 h-5 text-gray-600 dark:text-gray-300 group-hover:text-accent" />
          <span class="absolute right-full mr-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            {{ action.label }}
          </span>
        </button>
      </div>
    </transition>
    
    <button
      @click="toggleExpanded"
      class="accent-btn p-4 rounded-full shadow-lg hover-lift relative overflow-hidden group"
    >
      <transition name="fab-icon" mode="out-in">
        <PlusIcon v-if="!expanded" key="plus" class="w-6 h-6" />
        <XIcon v-else key="x" class="w-6 h-6" />
      </transition>
      
      <!-- Ripple effect -->
      <span class="absolute inset-0 rounded-full bg-white opacity-0 group-active:opacity-20 transition-opacity"></span>
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const expanded = ref(false)

const actions = ref([
  {
    id: 'task',
    label: 'New Task',
    icon: 'PlusIcon',
    handler: () => console.log('Create new task')
  },
  {
    id: 'drone',
    label: 'Deploy Drone',
    icon: 'DroneIcon',
    handler: () => console.log('Deploy drone')
  },
  {
    id: 'report',
    label: 'Generate Report',
    icon: 'DocumentIcon',
    handler: () => console.log('Generate report')
  },
  {
    id: 'emergency',
    label: 'Emergency Stop',
    icon: 'StopIcon',
    handler: () => console.log('Emergency stop all drones')
  }
])

const toggleExpanded = () => {
  expanded.value = !expanded.value
}

// Icon components
const PlusIcon = { template: '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>' }
const XIcon = { template: '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>' }
const DroneIcon = { template: '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/></svg>' }
const DocumentIcon = { template: '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>' }
const StopIcon = { template: '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 10h6v4H9z"/></svg>' }
</script>

<style scoped>
.fab-menu-enter-active,
.fab-menu-leave-active {
  transition: all 0.3s ease;
}
.fab-menu-enter-from,
.fab-menu-leave-to {
  opacity: 0;
  transform: scale(0.8) translateY(10px);
}

.fab-icon-enter-active,
.fab-icon-leave-active {
  transition: transform 0.2s ease;
}
.fab-icon-enter-from {
  transform: rotate(45deg);
}
.fab-icon-leave-to {
  transform: rotate(-45deg);
}
</style>
